import { ImportLinesCount } from "@/apps/dashboard/catalog/core/domain/ImportLinesCount";

export class ImportReport {
  constructor(
    public readonly error: string | null,
    public readonly linesCount: ImportLinesCount,
    public readonly ignoredLines: string[]
  ) {}
}
